export default import.meta.ROLLUP_FILE_URL_ucbtaphjwxTB1wovYSR2Pw